module.exports = __webpack_public_path__ + "static/darkPop-50a185512890fcf1c3c1cac1f424049f.wav";